import { LeaveComponent } from "../../components";

export default function LeaveRegistrationDetailPage() {
  return <LeaveComponent.LeaveRegistrationDetail />;
}
